const appConfig = {
  apiBaseUrl: process.env.REACT_APP_API_ENDPOINT,
  /**
   * The public site, for "view this on the live site" links out of the admin.
   *
   * Env-var first with a literal fallback, deliberately. The channel stream URL
   * is currently a hardcoded literal in three places across two hostnames
   * (`stream.theshortfilmshow.com` in admin, `tsfs-stream.b-cdn.net` in the
   * stitcher and the live player) with nothing tying them together — the day
   * that origin moves, some of it breaks and some does not. One place, one
   * override.
   */
  publicSiteUrl: process.env.REACT_APP_PUBLIC_SITE_URL || "https://theshortfilmshow.com",
  pdfBaseUrl: `${process.env.REACT_APP_API_ENDPOINT}bucket/catalogues/`,
  authenticatedEntryPath: "/app/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/app/account/kyc-form",
  enableMock: false,
};

export default appConfig;
